<template>
    <div class="page-content" id="device-list">
        <Titlebar :incrustation="'beepiz-folder'">
            <h1>{{ $t('device.group.titles.list') }}</h1>
        </Titlebar>
        <UiCard>
            <SuperTable
                ref="tableGroups"
                :tableColumns="tableColumns"
                :tableData="tableData"
                @sort="handleSort"
                @filter="handleFilter"
                @delete="handleDelete"
            />
        </UiCard>
        <Toolbar>
            <div class="row">
                <div class="col">
                    <Btn :class="'default'" v-if="useDvFlagAccess('beepiz-group-can:create')">
                        <router-link  to="/devices/groups/new" tag="span"><i class="fa fa-plus fa-fw"></i><span>{{ $t('device.group.btns.add') }}</span></router-link>
                    </Btn>
                </div>
                <div class="col center">
                    <Pagination ref="pagination" @change="handlePagination"></Pagination>
                </div>
                <div class="col">
                </div>
            </div>
        </Toolbar>
    </div>
</template>

<script>

    import axios from 'axios';
    import API from '@/services/API.js';
    import Globals from '@/services/globals.js';
    import Utils from '@/services/utils.js'
    import Titlebar from "@/components/ui/Titlebar";
    import Toolbar from "@/components/ui/Toolbar";
    import Btn from "@/components/ui/Button";
    import Pagination from "@/components/ui/Pagination";
    import SuperTable from "@/components/ui/Table";
    import UiCard from "@/components/ui/Card";

    import Association from '@/views/devices/Association';

    import _indexOf from 'lodash/indexOf'
    import {useDvFlag, useDvFlagAccess} from "../../../services/featureFlag";

    export default {
        name: 'ProfilesList',
        components: {
            Titlebar,
            Toolbar,
            UiCard,
            Btn,
            Pagination,
            SuperTable,
            Association
        },
        data: () => ({
            count: 0,
            showActions: false,
            config: {
                perpage: Globals.perPage,
                fields: [],
                page: 1,
                filter: {
                    like: [],
                    equals: []
                },
                sort: []
            },
            tableColumns: {
                global: {
                    sortable: false,
                    noItemsMsg: window.V.$i18n.t('device.group.emptyTable')
                },
                columns: [
                    {
                        key: 'name',
                        label: Utils.t('device.group.name'),
                        showPopup: false,
                        activeFilter: '',
                        activeSort: false,
                        sortable: true,
                        filter: {
                            type: 'text'
                        },
                        width: '60%',
                        linkTo: useDvFlagAccess("beepiz-group-can:update") ? '/devices/groups/:id' : null,
                    },
                    {
                        key: 'count',
                        label: Utils.t('device.group.nbdevices'),
                        showPopup: false,
                        activeFilter: '',
                        activeSort: false,
                         sortable: false,
                        filter: false,
                        width: '30%'
                    },
                ],
                rowActions: {
                    width: '10%',
                    actions: [
                        {
                            label: Utils.t('global.delete'),
                            class: 'fa fa-trash',
                            event: 'delete'
                        }
                    ]
                }
            },
            tableData: []
        }),

        created(){

        },

        methods: {
          useDvFlagAccess,
          useDvFlag,
            handlePagination: function (page) {
                this.config.page = page;
                this.loadData();
            },
            handleSort: function () {
                this.config.sort = [];
                for (var colKey in this.tableColumns.columns) {
                    var col = this.tableColumns.columns[colKey];
                    if (col.activeSort) {
                        this.config.sort.push(col.activeSort + col.key);
                    }
                }
                this.loadData();
            },
            handleFilter: function () {
                this.config.page = 1;
                this.config.filter.like = [];
                this.config.filter.equals = [];
                for (var colKey in this.tableColumns.columns) {
                    var col = this.tableColumns.columns[colKey];
                    if (col.activeFilter != '') {
                        if (col.filter && col.filter.type == 'text') {
                            this.config.filter.like.push(col.key + ':' + col.activeFilter);
                        }
                        if (col.filter && col.filter.type == 'list') {
                            this.config.filter.equals.push(col.key + ':' + col.activeFilter);
                        }
                    }
                }
                this.loadData();
            },
            handleDelete: function(item){
                var vThis = this;

                window.Vfc.$refs.confirm.show({
                    title: Utils.t('global.deleteModalTitle'),
                    content: Utils.tc('device.group.deleteConfirm',item.count,{count:item.count}),
                    callbackYes: function () {
                        window.Vfc.$refs.loading.show();
                        axios.delete(API.route(API.endpoints.groups.delete, {groupId: item.id}))
                            .then(response => {
                                if(vThis.tableData.length == 1 && vThis.config.page > 1){
                                    vThis.config.page--;
                                }
                                vThis.loadData();
                            })
                    }
                });
            },
            toggleActions: function () {
                this.showActions = !this.showActions;
            },
            loadData: function(){
                axios.get(API.endpoints.groups.index + API.constructQueryParams(this.config))
                    .then(response => {
                        this.tableData = response.data.data;
                        this.count = response.data.meta.pagination.total;
                        this.$refs.pagination.update(response.data.meta.pagination);
                        window.Vfc.$refs.loading.hide();
                    })
            }
        },

        watch: {
            tableData: {
                handler: function (val) {
                }
            }
        },

        mounted(){
          if(!useDvFlagAccess('beepiz-group-can:delete')){
            this.tableColumns.rowActions = {};
          }
          if (!useDvFlagAccess('beepiz-group-can:read')) {
            this.$router.push({name: 'AccessDenied', params: {slug: 'groups'}})
          } else {

            this.loadData();
          }
        }
    }
</script>

<style lang="scss" scoped>

</style>
